import PropTypes from 'prop-types';

const ArrowSquareLeftSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 24}`}
      height={`${height || 24}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z"
        fill={color}
      />
      <path
        d="M13.26 16.28C13.07 16.28 12.88 16.21 12.73 16.06L9.20004 12.53C8.91004 12.24 8.91004 11.76 9.20004 11.47L12.73 7.93997C13.02 7.64997 13.5 7.64997 13.79 7.93997C14.08 8.22997 14.08 8.70997 13.79 8.99997L10.79 12L13.79 15C14.08 15.29 14.08 15.77 13.79 16.06C13.65 16.21 13.46 16.28 13.26 16.28Z"
        fill={color}
      />
    </svg>
  );
};

ArrowSquareLeftSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ArrowSquareLeftSvg;
